<app-document-add
  [contractObject]="contractObject"
  [ofwcaObject]="ofwcaObject"
  [partnerObject]="partnerObject"
  [krkObject]="krkObject"
  [registrationObject]="registrationObject"
  [insuranceCompanyObject]="insuranceCompanyObject"
  [facilitiesVerificationObject]="facilitiesVerificationObject"
  [personalDataChangeObject]="personalDataChangeObject"
  [competitionImportRowObject]="competitionImportRowObject"
  [deviceObject]="deviceObject"
  (documentCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
  [allowedTypes]="types"
  [option]="option"
  [register]="register"
></app-document-add>
